import React, { Component } from 'react';
import * as d3 from "d3";
import numeral from "numeral";
import tooltip from "./Tooltip.js";
import utils from "./utils.js";
const customFormat = (value, format) => {
  if(typeof format === 'string'){
    return numeral(value).format(format)
  } else if (typeof format === 'function') {
    return format(value)
  }else{
    return value;
  }
}

export default class BollingerBands extends Component {
  constructor(props) {
    super(props)

    
  }
  componentDidMount() {
    this.renderArea()
  }
  componentWillReceiveProps(nextProps){
    if((!typeof(nextProps.lineChartChildComponen)=='object') || (nextProps.lineChartChildComponen==null)){
      this.renderArea(nextProps)
    }
    
  }

  componentDidUpdate() {
    // this.renderArea()
  }

  renderArea(nextProps){
    var { mainDivId,id,yAxisScale,xAxisScale, margins, data, svgDimensions,xField,yField,strokeColor,lineStyle,isGroupBar,groupIndex,curveStyle,type,xAxisData,
          dataLabels,marker,tooltip,name,showLineChartTooltip,hideLineChartTooltip,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition,gridLineYAxis,path } =nextProps || this.props;
    curveStyle=(curveStyle!=undefined || curveStyle!=null) ? curveStyle : 'curveLinear';
    const { height } = svgDimensions;
    var chartHeight=this.props.svgDimensions.height-margins.top-margins.bottom;
    var defaultDataLabelFormat=function(d){
      return d;
    };//"0,0.[00]"
    tooltipStyle.format= tooltipStyle.format!=undefined ? tooltipStyle.format : ((yAxisScale.labels && yAxisScale.labels.format) || defaultDataLabelFormat);
    tooltipStyle.prefix= tooltipStyle.prefix!=undefined ? tooltipStyle.prefix : ((yAxisScale.labels && yAxisScale.labels.prefix) || '');
    tooltipStyle.postfix= tooltipStyle.postfix!=undefined ? tooltipStyle.postfix : ((yAxisScale.labels && yAxisScale.labels.postfix) || '');
    // var area = d3.area()
    // .curve(d3[curveStyle])
    // .x(function(d) { 
    //     return xAxisScale.scale(d[xField])+(xAxisScale.scale.bandwidth()/2); 
    // })
    // .y0(svgDimensions.height- margins.bottom)
    // .y1(function(d) { 
    //     return yAxisScale.scale(d[yField]);
    //  });

    // var curveStyle = 'curveLinear';
    // if(type=='spline'){
    //     curveStyle = 'curveMonotoneX';
    // }
    var preparedData=[];
    xAxisData.forEach(function(d,index){
      preparedData.push({
        xAxisValue:(d!=null && typeof(d)=='object') ? d.data : d,
        yAxisValue:(data[index]!=null && typeof(data[index])=='object') ? data[index]["data"]:data[index],
        fillColor:(data[index]!=null && typeof(data[index])=='object') ? data[index]["fillColor"]:null,
      });
    });

    var preparedDataUpper=[];
    xAxisData.forEach(function(d,index){
      preparedDataUpper.push({
        xAxisValue:(d!=null && typeof(d)=='object') ? d.data : d,
        yAxisValue:(data[index]!=null && typeof(data[index])=='object') ? data[index]["upper"]:data[index]
      });
    });

    var preparedDataLower=[];
    xAxisData.forEach(function(d,index){
      preparedDataLower.push({
        xAxisValue:(d!=null && typeof(d)=='object') ? d.data : d,
        yAxisValue:(data[index]!=null && typeof(data[index])=='object') ? data[index]["lower"]:data[index]
      });
    });

    var fillColor=(lineStyle.fillColor ? lineStyle.fillColor : strokeColor);
    var fillColorUpper=(lineStyle.fillColorUpper ? lineStyle.fillColorUpper : strokeColor);
    var fillColorLower=(lineStyle.fillColorLower ? lineStyle.fillColorLower : strokeColor);

    var strokeOpacity=(lineStyle.strokeOpacity ? lineStyle.strokeOpacity : 1);
    var strokeOpacityUpper=(lineStyle.strokeOpacityUpper ? lineStyle.strokeOpacityUpper : 1);
    var strokeOpacityLower=(lineStyle.strokeOpacityLower ? lineStyle.strokeOpacityLower : 1);


    var strokeWidth=(lineStyle.strokeWidth ? lineStyle.strokeWidth : 2);
    var strokeWidthUpper=(lineStyle.strokeWidthUpper ? lineStyle.strokeWidthUpper : 2);
    var strokeWidthLower=(lineStyle.strokeWidthLower ? lineStyle.strokeWidthLower : 2);

    var valueline = d3.line()
    .curve(d3[curveStyle])
    .x(function(d) { return xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2);  })
    .y(function(d) { return yAxisScale.scale(d.yAxisValue);  });

    d3.selectAll('#BollingerChartContainer_'+this.props.id).selectAll('*').remove();
    d3.selectAll('#BollingerChartContainerUpper_'+this.props.id).selectAll('*').remove();
    d3.selectAll('#BollingerChartContainerLower_'+this.props.id).selectAll('*').remove();
    //CBT:Middle Line
    d3.selectAll('#BollingerChartContainer_'+this.props.id)
    .append("path")
    .data([preparedData])
    .style("fill-opacity",0)
    .style("stroke-opacity",strokeOpacity)
    .attr("stroke",fillColor)
    .attr("stroke-width",strokeWidth)
    .attr("class", "Line")
    .attr("d", valueline);

    //CBT:upper Line
    d3.selectAll('#BollingerChartContainerUpper_'+this.props.id)
    .append("path")
    .data([preparedDataUpper])
    .style("fill-opacity",0)
    .style("stroke-opacity",strokeOpacityUpper)
    .attr("stroke",fillColorUpper)
    .attr("stroke-width",strokeWidthUpper)
    .attr("class", "Line")
    .attr("d", valueline);

    //CBT:lower Line
    d3.selectAll('#BollingerChartContainer_'+this.props.id)
    .append("path")
    .data([preparedDataLower])
    .style("fill-opacity",0)
    .style("stroke-opacity",strokeOpacityLower)
    .attr("stroke",fillColorLower)
    .attr("stroke-width",strokeWidthLower)
    .attr("class", "Line")
    .attr("d", valueline);

    var that=this;
     //CBT:this is for data label middle
    if(dataLabels!=undefined && dataLabels !=null && dataLabels.enabled==true){
      var format=dataLabels.format || (yAxisScale.labels && yAxisScale.labels.format) || defaultDataLabelFormat;
      var prefix=dataLabels.prefix || (yAxisScale.labels && yAxisScale.labels.prefix) || "";
      var postfix=dataLabels.postfix || (yAxisScale.labels && yAxisScale.labels.postfix) || "";
      d3.selectAll('#LineChartLabelTextContainer_'+that.props.id).selectAll('*').remove();
      data.forEach(function(datum,index) {
        datum=(datum!=null && typeof(datum)=='object') ? datum["data"]:datum;
        var xAxisLabels= (xAxisData[index]!=null && typeof(xAxisData[index])=='object') ? xAxisData[index]["data"]  :xAxisData[index];
        var style=$.extend({'textAnchor':'middle'},false,(dataLabels && dataLabels.style ? dataLabels.style :{}));
          d3.selectAll('#LineChartLabelTextContainer_'+that.props.id)
          .append('text')
          .attr("x",xAxisScale.scale(xAxisLabels)+(xAxisScale.scale.bandwidth()/2))
          .attr('y',yAxisScale.scale(datum)-5)
          .style("fill",'#000')
          .attr('style',utils.convertReactStyleToHtml(style))
          .text(prefix+""+customFormat(datum,format)+""+postfix );
        })
    }
    //CBT:this is for data label Upper
    if(dataLabels!=undefined && dataLabels !=null && dataLabels.enabledUpper==true){
      var format=dataLabels.formatUpper || (yAxisScale.labels && yAxisScale.labels.format) || defaultDataLabelFormat;
      var prefix=dataLabels.prefixUpper || (yAxisScale.labels && yAxisScale.labels.prefix) || "";
      var postfix=dataLabels.postfixUpper || (yAxisScale.labels && yAxisScale.labels.postfix) || "";
      d3.selectAll('#LineChartLabelTextContainerUpper_'+that.props.id).selectAll('*').remove();
      data.forEach(function(datum,index) {
        datum=(datum!=null && typeof(datum)=='object') ? datum["upper"]:datum;
        var xAxisLabels= (xAxisData[index]!=null && typeof(xAxisData[index])=='object') ? xAxisData[index]["data"]  :xAxisData[index];
        var style=$.extend({'textAnchor':'middle'},false,(dataLabels && dataLabels.styleUpper ? dataLabels.styleUpper :{}));
          d3.selectAll('#LineChartLabelTextContainerUpper_'+that.props.id)
          .append('text')
          .attr("x",xAxisScale.scale(xAxisLabels)+(xAxisScale.scale.bandwidth()/2))
          .attr('y',yAxisScale.scale(datum)-5)
          .style("fill",'#000')
          .attr('style',utils.convertReactStyleToHtml(style))
          .text(prefix+""+customFormat(datum,format)+""+postfix );
        })
    }
    //CBT:this is for data label Lower
    if(dataLabels!=undefined && dataLabels !=null && dataLabels.enabledLower==true){
      var format=dataLabels.formatLower || (yAxisScale.labels && yAxisScale.labels.format) || defaultDataLabelFormat;
      var prefix=dataLabels.prefixLower || (yAxisScale.labels && yAxisScale.labels.prefix) || "";
      var postfix=dataLabels.postfixLower || (yAxisScale.labels && yAxisScale.labels.postfix) || "";
      d3.selectAll('#LineChartLabelTextContainerLower_'+that.props.id).selectAll('*').remove();
      data.forEach(function(datum,index) {
        datum=(datum!=null && typeof(datum)=='object') ? datum["lower"]:datum;
        var xAxisLabels= (xAxisData[index]!=null && typeof(xAxisData[index])=='object') ? xAxisData[index]["data"]  :xAxisData[index];
        var style=$.extend({'textAnchor':'middle'},false,(dataLabels && dataLabels.styleLower ? dataLabels.styleLower :{}));
          d3.selectAll('#LineChartLabelTextContainerLower_'+that.props.id)
          .append('text')
          .attr("x",xAxisScale.scale(xAxisLabels)+(xAxisScale.scale.bandwidth()/2))
          .attr('y',yAxisScale.scale(datum)-5)
          .style("fill",'#000')
          .attr('style',utils.convertReactStyleToHtml(style))
          .text(prefix+""+customFormat(datum,format)+""+postfix );
        })
    }

    //CBT:This is for marker
    var globalTooltipShowLine=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.showLine || false ) : false;
    var globalTooltipCategory=(globalTooltip!=null && typeof(globalTooltip)=='object') ? (globalTooltip.category || '' ) : '';
    var symbol=marker.symbol || 'circle';
    
    var fillColorMarker=(marker.fillColor!=undefined && marker.fillColor !=null) ? marker.fillColor :'transparent';

    var strokeColorMarker=(marker.strokeColor!=undefined && marker.strokeColor !=null) ? marker.strokeColor :'transparent';
    var strokeWidthMarker=(marker.strokeWidth!=undefined && marker.strokeWidth !=null) ? marker.strokeWidth :"0px";
    var radius=marker.radius || 5;
    var hilightColorMarker=(marker.hilightColor!=undefined && marker.hilightColor !=null) ? marker.hilightColor : fillColorMarker;
    var hilightStrokeColorMarker=(marker.hilightStrokeColor!=undefined && marker.hilightStrokeColor !=null) ? marker.hilightStrokeColor : strokeColorMarker;
    var hilightStrokeWidthMarker=(marker.hilightStrokeWidth!=undefined && marker.hilightStrokeWidth !=null) ? marker.hilightStrokeWidth : strokeWidthMarker;
    var hilightRadius=marker.hilightRadius || radius;

    var fillColorMarkerUpper=(marker.fillColorUpper!=undefined && marker.fillColorUpper !=null) ? marker.fillColorUpper :'transparent';
    var strokeColorMarkerUpper=(marker.strokeColorUpper!=undefined && marker.strokeColorUpper !=null) ? marker.strokeColorUpper :'transparent';
    var strokeWidthMarkerUpper=(marker.strokeWidthUpper!=undefined && marker.strokeWidthUpper !=null) ? marker.strokeWidthUpper :"0px";
    var radiusUpper=marker.radiusUpper || 5;
    var hilightColorMarkerUpper=(marker.hilightColorUpper!=undefined && marker.hilightColorUpper !=null) ? marker.hilightColorUpper : fillColorMarker;
    var hilightStrokeColorMarkerUpper=(marker.hilightStrokeColorUpper!=undefined && marker.hilightStrokeColorUpper !=null) ? marker.hilightStrokeColorUpper : strokeColorMarker;
    var hilightStrokeWidthMarkerUpper=(marker.hilightStrokeWidthUpper!=undefined && marker.hilightStrokeWidthUpper !=null) ? marker.hilightStrokeWidthUpper : strokeWidthMarker;
    var hilightRadiusUpper=marker.hilightRadiusUpper || radius;

    var fillColorMarkerLower=(marker.fillColorLower!=undefined && marker.fillColorLower !=null) ? marker.fillColorLower :'transparent';
    var strokeColorMarkerLower=(marker.strokeColorLower!=undefined && marker.strokeColorLower !=null) ? marker.strokeColorLower :'transparent';
    var strokeWidthMarkerLower=(marker.strokeWidthLower!=undefined && marker.strokeWidthLower !=null) ? marker.strokeWidthLower :"0px";
    var radiusLower=marker.radiusLower || 5;
    var hilightColorMarkerLower=(marker.hilightColorLower!=undefined && marker.hilightColorLower !=null) ? marker.hilightColorLower : fillColorMarker;
    var hilightStrokeColorMarkerLower=(marker.hilightStrokeColorLower!=undefined && marker.hilightStrokeColorLower !=null) ? marker.hilightStrokeColorLower : strokeColorMarker;
    var hilightStrokeWidthMarkerLower=(marker.hilightStrokeWidthLower!=undefined && marker.hilightStrokeWidthLower !=null) ? marker.hilightStrokeWidthLower : strokeWidthMarker;
    var hilightRadiusLower=marker.hilightRadiusLower || radius;


    if(symbol=='circle'){
      d3.selectAll("#LineChartMarkerContainer_"+that.props.id).selectAll('*').remove();
      d3.selectAll("#LineChartMarkerContainerUpper_"+that.props.id).selectAll('*').remove();
      d3.selectAll("#LineChartMarkerContainerLower_"+that.props.id).selectAll('*').remove();
      var markersCircle=d3.selectAll("#LineChartMarkerContainer_"+that.props.id)
      .selectAll("circle")
      .data(preparedData).enter()
      .append('circle')
      .attr("data",function(d,index){
              var globalData={xAxisTooltipsLabel:d.xAxisValue,
                dataIndex:index,
                x:xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2),
                y:yAxisScale.scale(d.yAxisValue),
                r:radius
              }
              return JSON.stringify(globalData);
      })
      .attr('cx',function(d){
        return xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2)
      })
      .attr('globalX',function(d){
        return (xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2)).toString().split(".").join("_");
      })
      .attr('cy',function(d){
        return yAxisScale.scale(d.yAxisValue)
      })
      .attr("r",function(d){
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightRadius;
        }else{
        return radius;
        }
      })
      .style("stroke-width",function(d){
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightStrokeWidthMarker;
        }else{
          return strokeWidthMarker;
        }
      })
      .style("stroke",function(d){
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightStrokeColorMarker;
        }else{
          return strokeColorMarker;
        }
      })
      .style("fill",function(d){
        return d.fillColor!=null ? d.fillColor : fillColorMarker;
      })
      .attr("originalfill",function(d){
        return fillColorMarker;
      });

      var markersCircleUpper=d3.selectAll("#LineChartMarkerContainerUpper_"+that.props.id)
      .selectAll("circle")
      .data(preparedDataUpper).enter()
      .append('circle')
      .attr("data",function(d,index){
              var globalData={xAxisTooltipsLabel:d.xAxisValue,
                dataIndex:index,
                x:xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2),
                y:yAxisScale.scale(d.yAxisValue),
                r:radiusUpper
              }
              return JSON.stringify(globalData);
      })
      .attr('cx',function(d){
        return xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2)
      })
      .attr('globalX',function(d){
        return (xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2)).toString().split(".").join("_");
      })
      .attr('cy',function(d){
        return yAxisScale.scale(d.yAxisValue)
      })
      .attr("r",function(d){
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightRadiusUpper;
        }else{
        return radiusUpper;
        }
      })
      .style("stroke-width",function(d){
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightStrokeWidthMarkerUpper;
        }else{
          return strokeWidthMarkerUpper;
        }
      })
      .style("stroke",function(d){
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightStrokeColorMarkerUpper;
        }else{
          return strokeColorMarkerUpper;
        }
      })
      .style("fill",function(d){
        return fillColorMarkerUpper;
      })
      .attr("originalfill",function(d){
        return fillColorMarkerUpper;
      });

      var markersCircleLower=d3.selectAll("#LineChartMarkerContainerLower_"+that.props.id)
      .selectAll("circle")
      .data(preparedDataLower).enter()
      .append('circle')
      .attr("data",function(d,index){
              var globalData={xAxisTooltipsLabel:d.xAxisValue,
                dataIndex:index,
                x:xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2),
                y:yAxisScale.scale(d.yAxisValue),
                r:radiusLower
              }
              return JSON.stringify(globalData);
      })
      .attr('cx',function(d){
        return xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2)
      })
      .attr('globalX',function(d){
        return (xAxisScale.scale(d.xAxisValue)+(xAxisScale.scale.bandwidth()/2)).toString().split(".").join("_");
      })
      .attr('cy',function(d){
        return yAxisScale.scale(d.yAxisValue)
      })
      .attr("r",function(d){
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightRadiusLower;
        }else{
        return radiusLower;
        }
      })
      .style("stroke-width",function(d){
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightStrokeWidthMarkerLower;
        }else{
          return strokeWidthMarkerLower;
        }
      })
      .style("stroke",function(d){
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightStrokeColorMarkerLower;
        }else{
          return strokeColorMarkerLower;
        }
      })
      .style("fill",function(d){
        return fillColorMarkerLower;
      })
      .attr("originalfill",function(d){
        return fillColorMarkerLower;
      });
      
      //CBT:GridLine Start
      if(gridLineYAxis!=null && typeof(gridLineYAxis)=='object'){
        var hilightCirlce=null;
        var hilightAbove={};
        var hilightBellow={};
        var hilightMiddle={};
        var points=gridLineYAxis.points || [{y1:yAxisScale.scale.invert(chartHeight * 0.25),y2:yAxisScale.scale.invert(chartHeight * 0.25)},{y1:yAxisScale.scale.invert(chartHeight * 0.75),y2:yAxisScale.scale.invert(chartHeight * 0.75)}];
        // if(points.length==1){
        //   points.push({
        //     y1:0,
        //     y2:0 
        //   })
        // }
        points=points.sort(function(a,b){
          return a.y1-b.y1;
        });
        if(gridLineYAxis.hasOwnProperty("hilightCirlce") && typeof(gridLineYAxis.hilightCirlce)=='object' && gridLineYAxis.hilightCirlce!=null){
          if(gridLineYAxis.hilightCirlce.hasOwnProperty("above")){
            hilightAbove=gridLineYAxis.hilightCirlce.above;
          } 
          if(gridLineYAxis.hilightCirlce.hasOwnProperty("bellow")){
            hilightBellow=gridLineYAxis.hilightCirlce.bellow;
          }
          if(gridLineYAxis.hilightCirlce.hasOwnProperty("middle")){
            hilightMiddle=gridLineYAxis.hilightCirlce.middle;
          }
          var minRange=points.length==1 ? yAxisScale.scale(points[0]["y1"]) : (yAxisScale.scale(points[0]["y1"]) < yAxisScale.scale(points[1]["y1"]) ? yAxisScale.scale(points[0]["y1"]) :yAxisScale.scale(points[1]["y1"]));
          var maxRange=points.length==1 ? yAxisScale.scale(points[0]["y1"]) : (yAxisScale.scale(points[0]["y1"]) > yAxisScale.scale(points[1]["y1"]) ? yAxisScale.scale(points[0]["y1"]) :yAxisScale.scale(points[1]["y1"]));
          d3.selectAll(".LineChartMarkerContainer_"+mainDivId).selectAll("circle")
          .style("fill",function(d){
            var currentCy=parseFloat(this.getAttribute("cy"));
            var currentFillColor=d3.select(this).style("fill");
            if(currentCy<=minRange && hilightAbove.isHilight==true){  
              return (hilightAbove.fillColor || '#d0021b')
            }else if(currentCy>=maxRange && hilightBellow.isHilight==true){  
              return (hilightBellow.fillColor || '#d0021b')
            }else if(currentCy>=minRange && currentCy<=maxRange && hilightMiddle.isHilight==true){  
              return (hilightBellow.fillColor || '#d0021b')
            }else{
              return currentFillColor;
            }
          });

           
        }
      }
      //CBT:GridLine End
      markersCircle.transition().duration(300).style("fill",function(d){
        var currentFillColor=d3.select(this).style("fill");
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightColorMarker;
        }else{
          return currentFillColor;
        }
      });
      markersCircleUpper.transition().duration(300).style("fill",function(d){
        var currentFillColor=d3.select(this).style("fill");
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightColorMarkerUpper;
        }else{
          return currentFillColor;
        }
      });
      markersCircleLower.transition().duration(300).style("fill",function(d){
        var currentFillColor=d3.select(this).style("fill");
        if(globalTooltipShowLine==true &&  d.xAxisValue==globalTooltipCategory){
          return hilightColorMarkerLower;
        }else{
          return currentFillColor;
        }
      });
      // .style("stroke-opacity",0);
     
      //CBT:THis is for tooltips 
      if(tooltip==true){
        markersCircle.on("mouseenter",(e)=>{
          // d3.select(d3.event.target).transition().style("stroke-opacity",0.5);
          d3.select(d3.event.target).transition().style("stroke",hilightStrokeColorMarker);
          d3.select(d3.event.target).transition().style("stroke-width",hilightStrokeWidthMarker);
          d3.select(d3.event.target).transition().style("fill",hilightColorMarker);
          d3.select(d3.event.target).transition().attr("r",hilightRadius);
            showDetail({id:mainDivId,margins:margins,tooltip:tooltip},[{[e.xAxisValue]:e.yAxisValue,name:name}],d3.event,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition);
        })
        if(tooltipPosition.toLowerCase()=='cursor'){
            markersCircle.on("mousemove",(e,index)=>{
            showDetail({id:mainDivId,margins:margins,tooltip:tooltip},[{[e.xAxisValue]:e.yAxisValue,name:name}],d3.event,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition);
          });
        }
        markersCircle.on("mouseout",function(d,mouseEvent){
          // d3.select(d3.event.target).transition().style("stroke-opacity",0);
          d3.select(d3.event.target).transition().style("stroke",fillColorMarker);
          d3.select(d3.event.target).transition().style("stroke-width",strokeWidthMarker);
          d3.select(d3.event.target).transition().style("fill",fillColorMarker);
          d3.select(d3.event.target).transition().attr("r",radius);
          hideDetail();
        });

        markersCircleUpper.on("mouseenter",(e)=>{
          // d3.select(d3.event.target).transition().style("stroke-opacity",0.5);
          d3.select(d3.event.target).transition().style("stroke",hilightStrokeColorMarkerUpper);
          d3.select(d3.event.target).transition().style("stroke-width",hilightStrokeWidthMarkerUpper);
          d3.select(d3.event.target).transition().style("fill",hilightColorMarkerUpper);
          d3.select(d3.event.target).transition().attr("r",hilightRadiusUpper);
            showDetail({id:mainDivId,margins:margins,tooltip:tooltip},[{[e.xAxisValue]:e.yAxisValue,name:name}],d3.event,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition);
        })
        if(tooltipPosition.toLowerCase()=='cursor'){
            markersCircleUpper.on("mousemove",(e,index)=>{
            showDetail({id:mainDivId,margins:margins,tooltip:tooltip},[{[e.xAxisValue]:e.yAxisValue,name:name}],d3.event,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition);
          });
        }
        markersCircleUpper.on("mouseout",function(d,mouseEvent){
          // d3.select(d3.event.target).transition().style("stroke-opacity",0);
          d3.select(d3.event.target).transition().style("stroke",fillColorMarkerUpper);
          d3.select(d3.event.target).transition().style("stroke-width",strokeWidthMarkerUpper);
          d3.select(d3.event.target).transition().style("fill",fillColorMarkerUpper);
          d3.select(d3.event.target).transition().attr("r",radiusUpper);
          hideDetail();
        });

        markersCircleLower.on("mouseenter",(e)=>{
          // d3.select(d3.event.target).transition().style("stroke-opacity",0.5);
          d3.select(d3.event.target).transition().style("stroke",hilightStrokeColorMarkerLower);
          d3.select(d3.event.target).transition().style("stroke-width",hilightStrokeWidthMarkerLower);
          d3.select(d3.event.target).transition().style("fill",hilightColorMarkerLower);
          d3.select(d3.event.target).transition().attr("r",hilightRadiusLower);
            showDetail({id:mainDivId,margins:margins,tooltip:tooltip},[{[e.xAxisValue]:e.yAxisValue,name:name}],d3.event,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition);
        })
        if(tooltipPosition.toLowerCase()=='cursor'){
            markersCircleLower.on("mousemove",(e,index)=>{
            showDetail({id:mainDivId,margins:margins,tooltip:tooltip},[{[e.xAxisValue]:e.yAxisValue,name:name}],d3.event,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition);
          });
        }
        markersCircleLower.on("mouseout",function(d,mouseEvent){
          // d3.select(d3.event.target).transition().style("stroke-opacity",0);
          d3.select(d3.event.target).transition().style("stroke",fillColorMarkerLower);
          d3.select(d3.event.target).transition().style("stroke-width",strokeWidthMarkerLower);
          d3.select(d3.event.target).transition().style("fill",fillColorMarkerLower);
          d3.select(d3.event.target).transition().attr("r",radiusLower);
          hideDetail();
        });
      }else if(tooltip!=false && typeof(tooltip)=='object'){
        markersCircle.on("mouseenter",null);
        markersCircle.on("mouseenter",(e)=>{
           var cx=xAxisScale.scale(e.xAxisValue)+(xAxisScale.scale.bandwidth()/2);
           var cy=yAxisScale.scale(e.yAxisValue)
           showLineChartTooltip(tooltip,{x:cx,y:cy,radius:radius,id:id,tooltipStyle:tooltipStyle}); 
        });
        markersCircle.on("mouseout",null);
        markersCircle.on("mouseout",function(d){
          hideLineChartTooltip();
        });


        markersCircleUpper.on("mouseenter",null);
        markersCircleUpper.on("mouseenter",(e)=>{
           var cx=xAxisScale.scale(e.xAxisValue)+(xAxisScale.scale.bandwidth()/2);
           var cy=yAxisScale.scale(e.yAxisValue)
           showLineChartTooltip(tooltip,{x:cx,y:cy,radius:radius,id:id,tooltipStyle:tooltipStyle}); 
        });
        markersCircleUpper.on("mouseout",null);
        markersCircleUpper.on("mouseout",function(d){
          hideLineChartTooltip();
        });

        markersCircleLower.on("mouseenter",null);
        markersCircleLower.on("mouseenter",(e)=>{
           var cx=xAxisScale.scale(e.xAxisValue)+(xAxisScale.scale.bandwidth()/2);
           var cy=yAxisScale.scale(e.yAxisValue)
           showLineChartTooltip(tooltip,{x:cx,y:cy,radius:radius,id:id,tooltipStyle:tooltipStyle}); 
        });
        markersCircleLower.on("mouseout",null);
        markersCircleLower.on("mouseout",function(d){
          hideLineChartTooltip();
        });
        
      }
    }
    //CBT:Marker End
    if(path!=undefined && (path.enabledUpper==true || path.enabledUpper==undefined) ){
      var fillColorUpper=(path.fillColorUpper!=undefined && path.fillColorUpper !=null) ? path.fillColorUpper :'transparent';
      var fillOpacityUpper=(path.fillOpacityUpper!=undefined && path.fillOpacityUpper !=null) ? path.fillOpacityUpper :1;
      var areaPoints=[];
      preparedData.forEach(function(dataPoint,index){
        var tempObj={};
        tempObj["x"]=xAxisScale.scale(dataPoint.xAxisValue)+(xAxisScale.scale.bandwidth()/2);
        tempObj["lower"]=yAxisScale.scale(preparedDataUpper[index].yAxisValue);
        tempObj["upper"]=yAxisScale.scale(dataPoint.yAxisValue);
        areaPoints.push(tempObj);
      });
      var areaGeneratorUpper = d3.area()
      .x(function(d) {
        return d.x;
      })
      .y0(function(d) {
        return d.lower;
      })
      .y1(function(d) {
        return d.upper;
      });
      if(typeof(fillColorUpper)=='object'){
        var linearGradient=fillColorUpper.linearGradient || [0,0,0,0];
        var stops=fillColorUpper.stops ||  [
          [0, 'red'],
          [1, 'green']
         ]
        d3.selectAll('#BoillingChartGradientColorContainer_'+this.props.id).append("linearGradient")
        .attr("id", "BoillingChartGradientColor_"+this.props.id)
        .attr("gradientUnits", "userSpaceOnUse")
        .attr("x1", linearGradient[0]*svgDimensions.width/100).attr("y1", linearGradient[1]*svgDimensions.height/100)
        .attr("x2", linearGradient[2]*svgDimensions.width/100).attr("y2", linearGradient[3]*svgDimensions.height/100)
        .selectAll("stop")
        .data([
          {offset: "0%", color: stops[0][1]},
          {offset: "100%", color:stops[1][1]}
        ])
        .enter().append("stop")
        .attr("offset", function(d) { return d.offset; })
        .attr("stop-color", function(d) { return d.color; });
        fillColorUpper="url(#BoillingChartGradientColor_"+this.props.id;
      }

      var areaUpper = areaGeneratorUpper(areaPoints);
      d3.selectAll("#LineChartPathContainerUpper_"+that.props.id).selectAll('*').remove();
      var areaContainerUpper=d3.selectAll("#LineChartPathContainerUpper_"+that.props.id)
        .append("path")
        .attr('d', areaUpper)
        .attr("fill",fillColorUpper)
        .attr("fill-opacity",fillOpacityUpper);
    }

    if(path!=undefined && (path.enabledLower==true || path.enabledLower==undefined) ){
      var fillColorLower=(path.fillColorLower!=undefined && path.fillColorLower !=null) ? path.fillColorLower :'transparent';
      var fillOpacityLower=(path.fillOpacityLower!=undefined && path.fillOpacityLower !=null) ? path.fillOpacityLower :1;
      var areaPoints=[];
      preparedData.forEach(function(dataPoint,index){
        var tempObj={};
        tempObj["x"]=xAxisScale.scale(dataPoint.xAxisValue)+(xAxisScale.scale.bandwidth()/2);
        tempObj["lower"]=yAxisScale.scale(dataPoint.yAxisValue);
        tempObj["upper"]=yAxisScale.scale(preparedDataLower[index].yAxisValue);
        areaPoints.push(tempObj);
      });
      var areaGeneratorLower = d3.area()
      .x(function(d) {
        return d.x;
      })
      .y0(function(d) {
        return d.lower;
      })
      .y1(function(d) {
        return d.upper;
      });
      if(typeof(fillColorLower)=='object'){
        var linearGradient=fillColorLower.linearGradient || [0,0,0,0];
        var stops=fillColorLower.stops ||  [
          [0, 'red'],
          [1, 'green']
         ]
        d3.selectAll('#BoillingChartGradientColorContainerLower_'+this.props.id).append("linearGradient")
        .attr("id", "BoillingChartGradientColorLower_"+this.props.id)
        .attr("gradientUnits", "userSpaceOnUse")
        .attr("x1", linearGradient[0]*svgDimensions.width/100).attr("y1", linearGradient[1]*svgDimensions.height/100)
        .attr("x2", linearGradient[2]*svgDimensions.width/100).attr("y2", linearGradient[3]*svgDimensions.height/100)
        .selectAll("stop")
        .data([
          {offset: "0%", color: stops[0][1]},
          {offset: "100%", color:stops[1][1]}
        ])
        .enter().append("stop")
        .attr("offset", function(d) { return d.offset; })
        .attr("stop-color", function(d) { return d.color; });
        fillColorLower="url(#BoillingChartGradientColorLower_"+this.props.id;
      }
      var areaLower = areaGeneratorLower(areaPoints);
      d3.selectAll("#LineChartPathContainerLower_"+that.props.id).selectAll('*').remove();
      var areaContainerLower=d3.selectAll("#LineChartPathContainerLower_"+that.props.id)
        .append("path")
        .attr('d', areaLower)
        .attr("fill",fillColorLower)
        .attr("fill-opacity",fillOpacityLower);
    }

  }
  componentWillUnmount(){
    hideDetail();    
  }

  render() {
    const { yAxisScale,xAxisScale, margins, data, svgDimensions,xField,yField,fillColor,isGroupBar,groupIndex } = this.props
    const { height } = svgDimensions;
    var that=this;

    return (
       <g>
         <g
        id={"BoillingChartGradientColorContainer_"+this.props.id}
        transform={"translate(0,0)"}></g>

        <g
        id={"BoillingChartGradientColorContainerLower_"+this.props.id}
        transform={"translate(0,0)"}></g>
        <g
        id={"LineChartPathContainerUpper_"+this.props.id}
        className={"LineChartPathContainerUpper_"+this.props.mainDivId}
          transform={"translate(0,0)"}>

        </g>
        <g
        id={"LineChartPathContainerLower_"+this.props.id}
        className={"LineChartPathContainerLower_"+this.props.mainDivId}
          transform={"translate(0,0)"}>

        </g>
         <g
        className={'BollingerChartContainer_'+this.props.id}
        id={"BollingerChartContainer_"+this.props.id}
        transform={"translate(0,0)"}
        ref={(el) => { this.areaContainer = el; }}
      />
      <g
        className={'BollingerChartContainerUpper_'+this.props.id}
        id={"BollingerChartContainerUpper_"+this.props.id}
        transform={"translate(0,0)"}
        ref={(el) => { this.areaContainer = el; }}
      />
      <g
        className={'BollingerChartContainerLower_'+this.props.id}
        id={"BollingerChartContainerLower_"+this.props.id}
        transform={"translate(0,0)"}
        ref={(el) => { this.areaContainer = el; }}
      />
      <g
        id={"LineChartLabelTextContainer_"+this.props.id}
          transform={"translate(0,0)"}>

        </g>
        <g
        id={"LineChartLabelTextContainerUpper_"+this.props.id}
          transform={"translate(0,0)"}>

        </g>
        <g
        id={"LineChartLabelTextContainerLower_"+this.props.id}
          transform={"translate(0,0)"}>

        </g>
        <g
        id={"LineChartMarkerContainer_"+this.props.id}
        className={"LineChartMarkerContainer_"+this.props.mainDivId}
          transform={"translate(0,0)"}>

        </g>
        <g
        id={"LineChartMarkerContainerUpper_"+this.props.id}
        className={"LineChartMarkerContainerUpper_"+this.props.mainDivId}
          transform={"translate(0,0)"}>

        </g>
        <g
        id={"LineChartMarkerContainerLower_"+this.props.id}
        className={"LineChartMarkerContainerLower_"+this.props.mainDivId}
          transform={"translate(0,0)"}>

        </g>
        
        { React.Children.count(this.props.children) ? 
        <g className="lineChartChildComponent">
          { React.Children.map(this.props.children,function(child,index){
              return (<g key={index}  className="lineChartChildComponent">{child}</g>);
            })
          }
        </g> 
        : null
        }  
        </g>
    )
  }
}

export function showDetail(props, data, mouseEvent,globalTooltip,globalTooltipData,tooltipStyle,tooltipPosition) {
  var defaultValueFormat=function(d){
      return d;
    };
  var labelFontSize =tooltipStyle.labelFontSize ||  "12px";
  var labelFontColor =tooltipStyle.labelFontColor ||  "black";
  var labelFontFamily = tooltipStyle.labelFontFamily ||  "";
  var valueFontSize =tooltipStyle.valueFontSize ||  "12px";
  var valueFontColor =tooltipStyle.valueFontColor ||  "black";
  var valueFontFamily =tooltipStyle.valueFontFamily ||  "";
  if(props.tooltip===true){
    var globalData=JSON.parse(mouseEvent.target.getAttribute("data") || "{}");
    var format=tooltipStyle.format || defaultValueFormat;
    var prefix=tooltipStyle.prefix || '';
    var postfix=tooltipStyle.postfix || '';
    data.map(function(d) {
      var content = `<tr>
          <td colspan="2" class="value"  style="text-align: center;letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
        d["name"]
      }</td></tr>`;
      delete d.name;
      var tooltipsContents = Object.keys(d);
      tooltipsContents.map(function(data) {
        content =
          content +
          `<tr><td class="key" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${labelFontSize};font-family:${labelFontFamily};color:${labelFontColor}">${data} </td>
              <td class="value" style="letter-spacing: 1.04px;line-height: 1.2;font-size:${valueFontSize};font-family:${valueFontFamily};color:${valueFontColor}">${
                prefix+""+customFormat( d[data],format)+""+postfix
          }</td></tr>`;
      });
  
      d["content"] = content;
      d["x"] = (tooltipPosition=="cursor")? d3.event.x : globalData.x + $("#" + props.id).offset().left;//d3.event.x;
      d["y"] =(tooltipPosition=="cursor")? d3.event.y : globalData.y+ $("#" + props.id).offset().top;// d3.event.y;
      d["mainDivId"] = props.id;
      d["marginLeft"] = props.margins.left;
      d["marginTop"] = props.margins.top;
    });
    tooltip.showTooltip(data, d3.event, "tooltip_map",(tooltipPosition=="cursor") ?  true :false,globalTooltip);//,isMouseMove,isGlobalTooltip
  }else{
  }  
  
}

export function hideDetail(d) {
  tooltip.hideTooltip();
}
